<template>
  <AppFormItem label="Veterinário">
    <AutocompleteApi
      :value="vet || { id: null, name: 'Nenhum' }"
      :valueId="vetId"
      :disabled="disabled"
      :search="fetchVets"
      @update:value="$emit('update:vet', $event)"
      @update:valueId="$emit('update:vetId', $event)"
      idField="vetAccountId"
    ></AutocompleteApi>
  </AppFormItem>
</template>

<script>
import AutocompleteApi from './AutocompleteApi.vue';
import { VetApi } from '../services/api';

export default {
  name: 'ServiceEditVet',
  components: {
    AutocompleteApi,
  },
  props: {
    vet: Object,
    vetId: Number,
    disabled: Boolean,
  },
  methods: {
    fetchVets: async (query) => {
      const response = await VetApi.fetch(query);
      response.results = response.results.map((result) => ({
        ...result,
        name: result.vetAccount.name,
      }));
      response.results.unshift({ id: null, name: 'Nenhum' });
      return response;
    },
  },
};
</script>

<style>
</style>
